export const BACKEND_RESPONSE_STATUS = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  SUCCESS: 'SUCCESS',
  NO_ACCREDITATION: 'NO_ACCREDITATION',
  ALREADY_SUBMITED: 'ALREADY_SUBMITED',
  QUOTA_EXCEEDED: 'QUOTA_EXCEEDED',
  USER_ACCOUNT_NOT_APPROVED: 'USER_ACCOUNT_NOT_APPROVED',
  ACCREDITATION_API_ERROR: 'ACCREDITATION_API_ERROR',
  USER_ACCOUNT_DISABILITY_CATEGORY_MISMATCH:
    'USER_ACCOUNT_DISABILITY_CATEGORY_MISMATCH',
  USER_ACCOUNT_REJECTED: 'USER_ACCOUNT_REJECTED',
  FORM_ALREADY_SUBMITTED_ERROR: 'FORM_ALREADY_SUBMITTED_ERROR',
  GUEST_MODE_DISABLED: 'GUEST_MODE_DISABLED',
};

export const BACKEND_RESPONSE_RESULT_SCREENS = {
  code: 'code',
  description: 'description',
  editButtonVisible: 'editButtonVisible',
  title: 'title',
};

export const SERVER_ERRORS = {
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  SERVER_UNAVAILABLE: 'SERVER_UNAVAILABLE',
  BAD_REQUEST: 'BAD_REQUEST',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
};

export const APP_ERRORS = {
  QUOTA_EXCEEDED: 'QUOTA_EXCEEDED',
  GUEST_MODE_DISABLED_ERROR: 'GUEST_MODE_DISABLED_ERROR',

  FORM_SUBMITTED: 'FORM_SUBMITTED',
  FORM_NOT_AVAILABLE: 'FORM_NOT_AVAILABLE',
  FORM_PENDING: 'FORM_PENDING',
  USER_ACCOUNT_NOT_APPROVED: 'USER_ACCOUNT_NOT_APPROVED',
  USER_ACCOUNT_DISABILITY_CATEGORY_MISMATCH:
    'USER_ACCOUNT_DISABILITY_CATEGORY_MISMATCH',
  USER_ACCOUNT_REJECTED: 'USER_ACCOUNT_REJECTED',
};
